export default __webpack_public_path__ + "static/media/年金险.b12d06f0.jpg";